module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/step4-pict01-full-98f092b6bd8c0a675bbe517bc1bc17a3.jpg";